<template>
  <li class="comment_list_li">
    <div class="prof profile_line">
      <div class="inner">
        <img v-if="data.photoThumb" :src="data.photoThumb" alt="" />
        <img
          v-else
          :src="
            require(`@/assets/front/images/v2/profiles/img_profile_${getProfileNum(
              data.userId,
            )}.png`)
          "
          alt=""
        />
      </div>
    </div>
    <div class="comment_txt_box">
      <div class="store_nm">{{ data.storeName }} 리뷰</div>
      <div class="nickname">
        <div class="left">
          {{ data.nickName }}
          <div class="score" :data-score="data.rating">
            <ul>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="review_types">
        <div class="buyer" v-if="data.isBuyer === 'Y'">
          <i class="i_buy_check"></i>실구매고객
        </div>
        <ul>
          <li v-if="data.reviewInternet === 1">
            인터넷상담
          </li>
          <li v-if="data.reviewMobile === 1">
            휴대폰상담
          </li>
          <li v-if="data.reviewVisit === 1">
            매장방문
          </li>
          <li v-if="data.reviewNormal === 1">
            일반상담
          </li>
        </ul>
      </div>
      <div class="editor">
        <div v-html="colorWord(data.comment)"></div>
      </div>
    </div>
  </li>
</template>
<script>
import { setKeyword, setProfile } from '@common/lib/common/utils';

export default {
  name: 'component-search-review-item',
  description: '검색 페이지 > 리뷰 아이템',
  props: {
    data: Object,
  },
  methods: {
    colorWord(content) {
      const keyword = this.$route.query.keyword;
      return setKeyword(content, keyword);
    },
    getProfileNum(userId) {
      return setProfile(userId);
    },
  },
};
</script>
